import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  VALIDATE_MDS_PAYER_SUCCESS,
  VALIDATE_MDS_PAYER_FAILURE,
  VALIDATE_MDS_PAYER_LOADING,
  VALIDATE_MDS_PAYER_RESET,
} = PatientPayersActions;

const initialState: any = {
  response: null,
  loading: false,
  isError: false,
};

export const validateMdsPayerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case VALIDATE_MDS_PAYER_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isError: false,
      };
    case VALIDATE_MDS_PAYER_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isError: true,
      };
    case VALIDATE_MDS_PAYER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case VALIDATE_MDS_PAYER_RESET:
      return initialState;
    default:
      return state;
  }
};
